import gql from 'graphql-tag';

const GET_ALL = gql `
    query all($perPage: Int!,$page: Int, $orderBy: [NomorSuratOrderByOrderByClause!], $where: NomorSuratWhereWhereConditions, $filter: NomorSuratFilterArgs){
        nomorSurat(first: $perPage, page: $page, orderBy: $orderBy, where: $where, filter: $filter){
            data{
                uuid,
                nomor,
                angka,
                tipe,
                kode_surat,
                tanggal
            }
            paginatorInfo {
                count
                total
                hasMorePages
                currentPage
                lastPage
                perPage
            }
        }
    }
`;

const GET_DETAIL = gql `
    query find($id: String!){
        nomorSuratByUuid(uuid : $id){
            id,
            uuid,
            nomor,
            angka,
            tipe,
            kode_surat,
            tanggal,
            surat_id,
            surat {
                uuid
                index,
                lampiran,
                perihal
            }
        }
    }
`;

const CREATE = gql `
    mutation($input:NomorSuratCreateInput!){
        nomorSuratCreate(input:$input){
            id,
            uuid,
            nomor,
            angka,
            tipe,
            kode_surat,
            surat_id,
            tanggal
        }
    }
`

const UPDATE = gql `
    mutation($id: ID!, $input:NomorSuratUpdateInput!){
        nomorSuratUpdate(id:$id, input:$input){
            uuid,
        }
    }
`

export {
  CREATE,
  GET_ALL,
  GET_DETAIL,
  UPDATE
}
